import { Component, OnInit } from '@angular/core';
import { FilterValue } from '../my-orders/my-orders.component';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import dayjs from 'dayjs';
import { FilterMyOrdersComponent } from '../../dialogs-otc/filter-my-orders/filter-my-orders.component';
import { SearchOrdersService } from 'src/app/order-to-cash/services-otc/search-orders.service';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { ItemService } from 'src/app/order-to-cash/services-otc/item.service';
import { OrdinaryMaterialModel } from 'src/app/order-to-cash/models-otc/ordinary-material-model';
import { PlantsModel } from 'src/app/order-to-cash/models-otc/plants-model';

@Component({
  selector: 'app-approved-orders',
  templateUrl: './approved-orders.component.html',
  styleUrl: './approved-orders.component.css',
  standalone: false
})
export class ApprovedOrdersComponent implements OnInit {

  displayedColumns: string[] = [
    'agentName', 
    'orderId', 
    'orderDate', 
    'clientName', 
    'orderValue', 
    'maxDiscount', 
    'orderStatus',
    'actions'];
  filterResult: FilterValue = {
    startDate: '',
    endDate: '',
    searchValue: '',
    statusIds: [],
    clientIds: []
  };
  searchValue: string;
  isFilterBtnVisible: boolean = false;
  dataSource = new MatTableDataSource<any>([]);
  isNoItemsFound: boolean = false;
  currentPage: number = 0;
  pageSize: number =  20;
  totalElements: number = 0;
  placeholder = '-';
  dateStingFormatting = 'DD.MM.YYYY';
  protected readonly dayjs = dayjs;
  fullMaterialList: OrdinaryMaterialModel [] = [];
  plantList: PlantsModel[] = [];

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private searchOrdersService: SearchOrdersService,
    private nav: NavBarComponent,
    private itemService: ItemService
  ) {}

  ngOnInit() {
    if(sessionStorage.getItem('approverOrdersFilter') !== null) {
      this.filterResult = JSON.parse(sessionStorage.getItem('approverOrdersFilter'));
      this.searchValue = this.filterResult?.searchValue;
      this.hideShowFilterReset();
    }
    this.filterResult.forApproved = true;
    this.populateAppovedOrdersList();
    this.populateFullMaterialList();
    this.populatePlantList();
  }

  searchOrders() {
    setTimeout(()=>{
      this.filterResult.searchValue = this.searchValue;
      sessionStorage.setItem('approverOrdersFilter', JSON.stringify(this.filterResult));
      this.populateAppovedOrdersList();
    },1400)
    this.hideShowFilterReset();
  }

  onPaginateChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.totalElements = event.length;
    this.populateAppovedOrdersList();
  }

  populateFullMaterialList() {
        this.itemService.getFullMaterialList().subscribe({
            next: (response) => {
                if(response) {
                    this.fullMaterialList = response;
                }
            }
        });
    }

    populatePlantList() {
        this.itemService.getPlantsList().subscribe({
            next: (response) => {
                if(response) {
                    this.plantList = response;
                }
            }
        })
    }

  openFilterDialog(){
    const dialogRef = this.dialog.open(FilterMyOrdersComponent, {
        data: {
          filterResult: this.filterResult,
          materialList: this.fullMaterialList,
          plantList: this.plantList
        }
    });

    dialogRef.afterClosed().subscribe(result => {
        if (result) {
            this.filterResult.startDate = result.startDate;
            this.filterResult.endDate = result.endDate;
            this.filterResult.clientIds = result.clientIds;
            this.filterResult.statusIds = result.statusIds;
            this.filterResult.materialIds = result.materialIds;
            this.filterResult.plantIds = result.plantIds;

            sessionStorage.setItem('approverOrdersFilter', JSON.stringify(this.filterResult));
        }
        this.populateAppovedOrdersList();
        this.hideShowFilterReset();
    });
  }

  reviewOrder(id:number){
    this.router.navigate([`/order-manager/order/${id}`]);
  }

  hideShowFilterReset(){
    this.isFilterBtnVisible = this.filterResult?.materialIds?.length > 0 || this.filterResult?.plantIds?.length > 0 || this.filterResult?.startDate?.length > 0 || this.filterResult?.endDate?.length > 0 || this.filterResult?.clientIds?.length > 0 || this.filterResult?.statusIds?.length > 0 || this.searchValue?.length > 0;
  }

  populateAppovedOrdersList() {
    this.nav.toggleLoading(true);

    this.isNoItemsFound = false;
    this.searchOrdersService.getOrderHistoryList(
      this.currentPage,
      this.pageSize,
      this.searchValue?.trim()?.toLocaleLowerCase(),
      this.filterResult?.clientIds,
      this.filterResult?.startDate,
      this.filterResult?.endDate,
      this.filterResult?.statusIds,
      this.filterResult?.plantIds,
      this.filterResult?.materialIds
    ).subscribe({
      next: (response) => {
        this.dataSource.data = response?.content;
        this.isNoItemsFound = response?.content?.length <= 0;
        this.nav.toggleLoading(false);
        this.totalElements = response?.totalElements;
      },
      error: () => {
        this.nav.toggleLoading(false);
        this.isNoItemsFound = true;
      }
    })
  }

  resetFilter(){
    sessionStorage.removeItem('approverOrdersFilter');
    // FORCE REFRESH BROWSER
    this.router.navigateByUrl("/order-manager/my-orders", { skipLocationChange: true }).then(() => {
        this.router.navigate(["/order-manager/approved-orders"]);
    });
  }

}
